import { render } from "./QrcodeGroup.vue?vue&type=template&id=573a542e&scoped=true"
const script = {}

import "./QrcodeGroup.vue?vue&type=style&index=0&id=573a542e&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573a542e"]])

export default __exports__